import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterMerchandiseTypesControllerForm } from "../controller/controller";
import { MasterOrganismColumns } from "./column/column";
import { fetchMasterMerchandiseTypesList } from "../../../../../../redux/actions/resources/master/merchandiseTypes/merchandiseTypes";
interface IMasterMerchandiseTypesList {
     widthPopUp:any;
    heigthPopUp:any;
}
export const MasterMerchandiseTypesList:React.FC<IMasterMerchandiseTypesList> = ({heigthPopUp, widthPopUp}) => {
    const dispatch = useAppDispatch();
    const { list, loading } = useAppSelector((state) => state.masterMerchandiseTypesList);
    const renderColumn = () => {
        return MasterOrganismColumns();
    };

    useEffect(() => {
        !list && !loading && dispatch(fetchMasterMerchandiseTypesList());
    }, []);

    return loading ? (
        <Skeleton rows={2}></Skeleton>
    ) : (
        <>
            <CustomDetailsList
                data={list ?? []}
                renderColumns={renderColumn}
                height={"calc(100vh - 10rem)"}
           />
            <MasterMerchandiseTypesControllerForm  heigthPopUp={heigthPopUp} widthPopUp={widthPopUp}/>
        </>
    );
};
